import PropTypes from "prop-types";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import { Link } from "@components/al_components/ALLink";
import { useTracking } from "@context/Tracking";
import { withALErrorBoundary } from "@helpers/ErrorBoundary/ALErrorBoundary";

function MenuLinkWithImage({ link, title, image, menuTitle, closeMenu }) {
  const { trackMenuClick } = useTracking();
  const isInternal = /^\/(?!\/)/.test(link); // check doesn't start with "/"

  const onMenuImageClick = () => {
    trackMenuClick({
      destinationUrl: link,
      menuTitle,
      categoryTitle: title,
      sourceType: "image",
    });
    closeMenu();
  };

  return (
    <li>
      {isInternal ? (
        <Link
          to={link}
          onClick={onMenuImageClick}
          className="flex flex-col items-start menu-image-link"
        >
          <GatsbyImage
            className="max-w-[180px] h-[225px]"
            image={getImage(image.desktopImage.gatsbyImageData)}
            alt={image.altText}
          />
          <span className="typo-micro font-bold mt-[10px] whitespace-normal inline-block menu-link-underline">
            {title}
          </span>
        </Link>
      ) : (
        <a
          href={link}
          onClick={onMenuImageClick}
          className="flex flex-col items-start menu-image-link"
        >
          <GatsbyImage
            className="max-w-[180px] h-[225px]"
            image={getImage(image.desktopImage.gatsbyImageData)}
            alt={image.altText}
          />
          <span className="typo-micro font-bold mt-[10px] whitespace-normal inline-block menu-link-underline">
            {title}
          </span>
        </a>
      )}
    </li>
  );
}

MenuLinkWithImage.propTypes = {
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.shape({
    altText: PropTypes.string.isRequired,
    desktopImage: PropTypes.shape({
      gatsbyImageData: PropTypes.object.isRequired,
    }).isRequired,
  }).isRequired,
  menuTitle: PropTypes.string.isRequired,
  closeMenu: PropTypes.func,
};

export default withALErrorBoundary({
  name: "MenuLinkWithImage",
  priority: "P2",
})(MenuLinkWithImage);
